export default "__VITE_ASSET__DZkYpVkV__"